import actions from './actions'
import mutations from './mutations'

const namespaced = true

const state = {
  redirectPath: null,
}

/*
 * ログイン認証を行うmodule
 */
const loginAuth = {
  namespaced,
  actions,
  mutations,
  state,
}

export default loginAuth
